import SearchSelect from "@ui-components/SearchSelect";
import React, {useContext, useState} from "react";
import CountryContext from "../CountryContext";
import {FormattedMessage} from "react-intl";


/**
 * This component is used as select on tables that needs
 * to fetch data from the backend.
 * It integrates with mu-tables events to refresh the table
 * based on selected filters.
 */
const COMPONENT_STYLE_OVERRIDE = {
  dropdownIndicator: (provided, state) => ({
    ...provided,
    padding: "2px 8px",
  }),
  clearIndicator: (provided, state) => ({
    ...provided,
    padding: "2px 8px",
  }),
  control: (provided, state) => ({
    ...provided,
    borderRadius: "1.3rem",
    borderColor: "transparent",
    boxShadow: "none !important",
    "&:hover": {
      borderColor: "transparent",
    },
    backgroundColor: "transparent",
    minHeight: "33px",
    cursor: "pointer",
  }),
  singleValue: (provided, state) => ({
    ...provided,
    position: "absolute",
  }),
  placeholder: (provided, state) => ({
    ...provided,
    position: "absolute",
  }),
  input: (provided, state) => ({
    input: {
      border: 0,
      outline: 0,
      boxShadow: "none !important",
    },
  }),
}

const casInsenstive = (originalArray) => {
  const lowercaseArray = originalArray.map(str => str.toLowerCase());
  // Step 2: Remove duplicates using a Set
  const uniqueSet = new Set(lowercaseArray);
  // Step 3: Convert the Set back to an array
  const uniqueArray = [...uniqueSet];
  return uniqueArray;
}

const SuggestedUsersTableFilter =
  ({
     options,
     columnDef,
     onFilterChanged,
   }) => {

    // context
    const {country: {code}} = useContext(CountryContext);

    // state
    const [selected, setSelected] = useState(null);


    return (
      // @ts-ignore
      <div className={"mb-6"}>
        <SearchSelect
          options={options}
          onChange={(selected) => {
            if (selected.length === 0) {
              onFilterChanged((columnDef).tableData.id, null);
            } else {
              onFilterChanged((columnDef).tableData.id, selected.map((option) => option.value));
            }
            setSelected(selected);
          }}
          value={selected}
          isMulti={true}
          mainStyle="border-2 border-kerakoll-400 mt-1 mb-0"
          componentStyle={COMPONENT_STYLE_OVERRIDE}
          noOptionsMessage={() => <FormattedMessage id="type_to_search"/>}
          isClearable={true}
          isSearchable={false}
        />
      </div>
    )
  }

export default SuggestedUsersTableFilter